import { useState, useEffect, useContext } from "react"
import { AuthContext } from "../../../Context/authContext/AuthContext"
import "./bankCheck.scss"
import axios from "axios"
import Cookies from "universal-cookie"
import config from "../../../config/config"


function BankCheck({ display }) {
  const { user } = useContext(AuthContext)
  const initVerifastStatus = {
    received: false,
    pending: true,
    userMsg: "The tenant has submitted their income & expense verification, it may take up to several minutes for the results to appear."
  }
  const [showData, setShowData] = useState(true)
  const [verifastStatus, setVerifastStatus] = useState(initVerifastStatus)
  const [verifastData, setVerifastData] = useState({})
  const [reportUrl, setReportUrl] = useState("")


  useEffect(() => {
    const cookies = new Cookies()
    const apiConfig = {
      headers: {
        Authorization: "Bearer " + cookies.get("auth_token"),
      },
    }

    axios.get(
        `${config.BASE_URL}api/verifast/getReport?type=bank_verification&id=` + display.id,
      apiConfig
      )
      .then((response) => {
        if (response.data.status === 1) {
          setReportUrl(response.data.report_url)
        }
      }).catch((e) => {
        console.log("Error:", e)
      })
  },[])


  const evaluateVerifast = () => {

    if (user.roles[0]?.name !== "landlord") {
      setVerifastStatus({
        ...verifastStatus,
        userMsg: "Your application has been sent, it may take several minutes to appear.",
        })
    }
    
    if (typeof display.verifast_data != 'undefined') {
      let parsedVerifastData = JSON.parse(display.verifast_data)

      setVerifastData(parsedVerifastData)
      if (verifastData.hasOwnProperty("status") && verifastData.status === "sent") {
        setVerifastStatus({
          ...verifastStatus,
          received: false,
          pending: true,
        })

      //  This is showing a comparison error, might need to be fixed.
      } else if (parsedVerifastData.applicantFinancialData != undefined) {
        setVerifastStatus({
          ...verifastStatus,
          received: true,
          pending: false,
        })
      }
    }
  }

  useEffect(() => {
    evaluateVerifast()
  }, [])

  return (
    <>
      <section className="bank-check-info mainContent">
        <div className="application-preview-badge">
          <div className="application-preview-badge__inner">
            <span>powered by</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xlink="http://www.w3.org/1999/xlink"
              width="101"
              height="20"
              viewBox="0 0 101 20"
              fill="none"
            >
              <g clipPath="url(#clip0_701_923)">
                <rect
                  x="0.466797"
                  width="77.2414"
                  height="20"
                  fill="url(#pattern0)"
                />
              </g>
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    href="#image0_701_923"
                    transform="translate(-0.00571987) scale(0.00404576 0.015625)"
                  />
                </pattern>
                <clipPath id="clip0_701_923">
                  <rect
                    width="100"
                    height="20"
                    fill="white"
                    transform="translate(0.466797)"
                  />
                </clipPath>
                <image
                  id="image0_701_923"
                  width="250"
                  height="64"
                  href="data:image/png;base64,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"
                />
              </defs>
            </svg>
          </div>
        </div>
        <div className="info-title-container-p">
          <div className="info-title">
            <div className="info__label info__label--completed">
              completed
            </div>
            <h2>
                <span className="mr-1">
                  income & expense verification
                </span>
              {(reportUrl !== "") && (
                <a
                  className="btn btn--download"
                  href={reportUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M480 352h-133.5l-45.25 45.25C289.2 409.3 273.1 416 256 416s-33.16-6.656-45.25-18.75L165.5 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96C512 366.3 497.7 352 480 352zM432 456c-13.2 0-24-10.8-24-24c0-13.2 10.8-24 24-24s24 10.8 24 24C456 445.2 445.2 456 432 456zM233.4 374.6C239.6 380.9 247.8 384 256 384s16.38-3.125 22.62-9.375l128-128c12.49-12.5 12.49-32.75 0-45.25c-12.5-12.5-32.76-12.5-45.25 0L288 274.8V32c0-17.67-14.33-32-32-32C238.3 0 224 14.33 224 32v242.8L150.6 201.4c-12.49-12.5-32.75-12.5-45.25 0c-12.49 12.5-12.49 32.75 0 45.25L233.4 374.6z" />
                  </svg>
                </a>
              )}
            </h2>
          </div>
          <div className="info-title-controls">
            <button
              className="btn btn--toggle btn--toggle-inverse"
              onClick={() => setShowData(!showData)}
            ></button>
          </div>
        </div>

        {/* SHOW WHEN VERIFAST STATUS IS SENT BUT NO DATA*/}
        {showData && verifastStatus.pending === true && (
          <div className="bank-check-container">
            <div className="row verified--container statusPending">
                <div className="circle-check--small"></div>
                <span className="verified--label">submitted &nbsp;</span>
                <p>{verifastStatus.userMsg}</p>
            </div>
          </div>
        )}

        {/* SHOW WHEN VERIFAST DATA IS POPULATED */}
        {showData && verifastStatus.received === true && (
          <>
            <div className="row bank-check-container">
            
              {(typeof verifastData.applicantFinancialData.monthly_payroll_income != 'undefined') ? (
                <div className="col-md-4">
                  <div className="bank-check-item">
                    <div className="bank-check-item__label">
                      Employment Income
                    </div>
                    <div className="bank-check-item__value">
                      $
                      {verifastData?.applicantFinancialData?.monthly_payroll_income}
                    </div>
                  </div>
                </div>
              ) : ( <></> )}
              
              {(typeof verifastData.applicantFinancialData.monthly_income != 'undefined') ? (
                <div className="col-md-4">
                  <div className="bank-check-item">
                    <div className="bank-check-item__label">
                      Other Income
                    </div>
                    <div className="bank-check-item__value">
                      $
                      {
                        verifastData.applicantFinancialData
                          .monthly_income
                      }
                    </div>
                  </div>
                </div>
              ) : ( <></> )}

              {(typeof verifastData.applicantFinancialData.monthly_government_income != 'undefined') ? (
                <div className="col-md-4">
                  <div className="bank-check-item">
                    <div className="bank-check-item__label">
                      Government Income
                    </div>
                    <div className="bank-check-item__value">
                      $
                      {verifastData?.applicantFinancialData?.monthly_government_income}
                    </div>
                  </div>
                </div>
              ) : ( <></> )}

              {(typeof verifastData.applicantFinancialData.balance_max != 'undefined') ? (
                <div className="col-md-4">
                  <div className="bank-check-item">
                    <div className="bank-check-item__label">
                      Closing Bank Balance
                    </div>
                    <div className="bank-check-item__value">
                      $
                      {verifastData?.applicantFinancialData?.balance_max}
                    </div>
                  </div>
                </div>
              ) : ( <></> )}
              
              {(typeof verifastData.applicantFinancialData.total_loan != 'undefined') ? (
                <div className="col-md-4">
                  <div className="bank-check-item">
                    <div className="bank-check-item__label">
                      Debt Payments
                    </div>
                    <div className="bank-check-item__value">
                      ${verifastData.applicantFinancialData.total_loan}
                    </div>
                  </div>
                </div>
              ) : ( <></> )}
              
              {(typeof verifastData.applicantFinancialData.rent_payment_average_values != 'undefined') ? (
                <div className="col-md-4">
                  <div className="bank-check-item">
                    <div className="bank-check-item__label">
                      Rent Payments
                    </div>
                    <div className="bank-check-item__value">
                      {
                        verifastData.applicantFinancialData
                          .rent_payment_average_values
                      }
                    </div>
                    {/**!rent_payment_average_values */}
                  </div>
                </div>
              ) : ( <></> )}
              
              {(typeof verifastData.applicantFinancialData.average_monthly_mortgage_payments != 'undefined') ? (
                <div className="col-md-4">
                  <div className="bank-check-item">
                    <div className="bank-check-item__label">
                      Mortgage Payments
                    </div>
                    <div className="bank-check-item__value">
                      {
                        verifastData.applicantFinancialData
                          .average_monthly_mortgage_payments
                      }
                    </div>
                    {/** !average_monthly_mortgage_payments */}
                  </div>
                </div>
              ) : ( <></> )}
              {/*          <div className="col-md-4">
              <div className="bank-check-item">
                <div className="bank-check-item__label">
                  Telecom Payments
                </div>
                <div className="bank-check-item__value">
                  $MISSING_DATA
                </div>
              </div>
            </div>*/}

            {(typeof verifastData.applicantFinancialData.monthly_utility_payments != 'undefined') ? (
              <div className="col-md-4">
                <div className="bank-check-item">
                  <div className="bank-check-item__label">
                    Utility Payments
                  </div>
                  <div className="bank-check-item__value">
                    {
                      verifastData.applicantFinancialData
                        .monthly_utility_payments
                    }
                  </div>
                  {/**monthly_utility_payments */}
                </div>
              </div>
            ) : ( <></> )}
              
              
              <div className="col-md-12">
                <p>*values are average monthly amounts</p>
              </div>
            </div>
          </>
        )}
      </section>
    </>

  )
}

export default BankCheck
